<svg width="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="18.75" transform="matrix(0 -1 -1 0 40 40)" stroke="currentColor" stroke-width="2.5" stroke-dasharray="5 5"/>
<path d="M23.75 30L13.75 20L23.75 10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
